import useLang from "hooks/useLang";
import React from "react";
import { Link } from "react-router-dom";

const OtherServices = () => {
  const { lang } = useLang();
  const services = [
    {
      icon: "icon ti-user",
      to: "/services/individual",
      title: lang.services.our_services.service_card_1_title,
      description: lang.services.our_services.service_card_1_description,
    },
    {
      icon: "icon ti-stats-up",
      to: "/services/accounting-compliance",
      title: lang.services.our_services.service_card_2_title,
      description: lang.services.our_services.service_card_2_description,
    },
    {
      icon: "icon ti-ruler-pencil",
      to: "/services/assistance",
      title: lang.services.our_services.service_card_3_title,
      description: lang.services.our_services.service_card_3_description,
    },
    {
      icon: "icon ti-comment-alt",
      to: "/services/advisory",
      title: lang.services.our_services.service_card_4_title,
      description: lang.services.our_services.service_card_4_description,
    },
    {
      icon: "icon ti-layers-alt",
      to: "/services/documentation",
      title: lang.services.our_services.service_card_5_title,
      description: lang.services.our_services.service_card_5_description,
    },
    {
      icon: "icon ti-alert",
      to: "/services/dispute",
      title: lang.services.our_services.service_card_6_title,
      description: lang.services.our_services.service_card_6_description,
    },
    {
      icon: "icon ti-shopping-cart-full",
      to: "/services/diligence",
      title: lang.services.our_services.service_card_7_title,
      description: lang.services.our_services.service_card_7_description,
    },
    {
      icon: "icon ti-stamp",
      to: "/services/registration",
      title: lang.services.our_services.service_card_8_title,
      description: lang.services.our_services.service_card_8_description,
    },
    {
      icon: "icon ti-shield",
      to: "/services/restitution",
      title: lang.services.our_services.service_card_9_title,
      description: lang.services.our_services.service_card_9_description,
    },
    {
      icon: "icon ti-brush",
      to: "/services/removal",
      title: lang.services.our_services.service_card_10_title,
      description: lang.services.our_services.service_card_10_description,
    },
    {
      icon: "icon ti-unlink",
      to: "/services/exempetion",
      title: lang.services.our_services.service_card_11_title,
      description: lang.services.our_services.service_card_11_description,
    },
    {
      icon: "icon ti-money",
      to: "/services/pricing",
      title: lang.services.our_services.service_card_12_title,
      description: lang.services.our_services.service_card_12_description,
    },
  ];
  // Shuffle array
  const shuffled = services.sort(() => 0.5 - Math.random());

  // Get sub-array of first n elements after shuffled
  let selected = shuffled.slice(0, 4);
  return (
    <React.Fragment>
      <div className="mt-4 pt-2">
        <div className="sd-title">
          <h6 className="fs-16 mb-3">{lang.others.popular_service}</h6>
        </div>
        <ul className="widget-popular-post list-unstyled my-4">
          {selected.map((popularPostDetails, key) => (
            <li
              className="d-flex mb-3 align-items-center pb-3 border-bottom"
              key={key}
            >
              <div class="icon-box">
                <span class={popularPostDetails.icon}></span>
              </div>
              <div className="flex-grow-1 text-truncate ms-3">
                <Link to={popularPostDetails.to}>
                  {popularPostDetails.title}
                </Link>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </React.Fragment>
  );
};

export default OtherServices;
